<template>
  <div class="image-card" :style="cardStyle">
    <!-- Sponsor Regions -->
    <div class="image-card__sponsor-regions--wrapper">
      <div class="image-card__sponsor-regions" v-if="limitedSponsorRegions">
        <div class="region-pill">
          {{ limitedSponsorRegions }}
        </div>
      </div>
    </div>


    <!-- Card Content -->
    <div class="image-card__content">
      <div class="image-card__main">
        <div class="image-card__main--left">
          <h3 class="image-card-title">{{ announcement.title }}</h3>
          <div class="image-card-date">
            <span class="image-card-date__location">{{ formattedLocation }}</span>
            <span v-if="hasEffectiveDate">  {{ formatDateRange(announcement.effectiveStartDate, announcement.effectiveEndDate) }}</span>
          </div>
          <p class="image-card-description">{{ announcement.shortDescription }}</p>
        </div>
      </div>

      <div class="image-card-footer">
        <button class="read-more" @click="visitNow(announcement.ctaLink)">
          {{ chapterStudioPageConstant.VISIT_NOW }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>

import { chapterStudioPageConstant } from "@/components/ChapterStudioPage/chapterStudioPage.constant";
import { formatWeekdayRange, formatDateRange } from "@/common/utils/dateTime";
import { mapGetters } from 'vuex';
import { storeGetters } from '@/store/storeGetters.constant';
import { openHtmlLink } from "@/common/utils/utils";
import { sizeFormattedImageUrl } from "@/common/utils/cloudinaryUtils";

export default {
  name: 'ImageAnnouncementCard',
  data() {
    return {
      chapterStudioPageConstant,
      formatWeekdayRange,
      formatDateRange,
      sizeFormattedImageUrl,
    };
  },
  props: {
    announcement: {
      type: Object,
      required: true,
    },
    currentIndex: {
      type: Number,
      required: false,
    },
    totalCards: {
      type: Number,
      required: false,
    },
  },
  computed: {
    ...mapGetters({
      isMobileAppBrowser: `${[storeGetters.isMobileAppBrowser]}`,
    }),
    cardStyle() {
      if (this.announcement.backgroundImage) {
        return {
          backgroundImage: `url(${sizeFormattedImageUrl(this.announcement.backgroundImage, 500, 650)}`,
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        };
      } else if (this.announcement.backgroundColor) {
        return {
          backgroundColor: this.announcement.backgroundColor,
        };
      }
      return {
        backgroundColor: this.chapterStudioPageConstant.DEFAULT_BACKGROUND_COLOR,
      };
    },
    limitedSponsorRegions() {
      let sponsorList = [];
      if (this.announcement.sponsorRegionsList && this.announcement.sponsorRegionsList.length) {
        sponsorList = this.announcement.sponsorRegionsList;
      } else if (this.announcement.sponsorDepartmentList && this.announcement.sponsorDepartmentList.length) {
        sponsorList = this.announcement.sponsorDepartmentList;
      }

      return sponsorList.slice(0, 4).join(', ');
    },
    formattedLocation() {
      return this.announcement.location || '';
    },
    hasEffectiveDate() {
      return (this.announcement.effectiveStartDate && this.announcement.effectiveStartDate.length)
          && (this.announcement.effectiveEndDate && this.announcement.effectiveEndDate.length);
    },
  },
  methods: {
    visitNow(announcementUrl) {
      openHtmlLink(announcementUrl, this.isMobileAppBrowser);
      return false;
    },
  },
};
</script>

<style scoped lang="scss">

@import "../../common/styles/_responsive.scss";
@import "../../common/styles/_commonClasses.scss";

.image-card {
  font-family: 'Helvetica',Roboto, 'sans-serif';
  position: relative;
  width:  100%;
  height: 266px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
  background-color: #d9c5a3;
  display: flex;
  flex-direction: column;
  padding: 10px 20px 20px 20px;

   &__sponsor-regions {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      justify-content: end;
      gap: 10px;
      margin-bottom: 5px;
      overflow: hidden;

    &--wrapper {
      width: 100%;
      display: flex;
      height: auto;
      justify-content: flex-end;
      min-height: 34px;
    }

     .region-pill {
        background-color: rgba(0, 0, 0, 0.6);
        color: #fff;
        padding: 4px 10px;
        font-size: 11px;
        font-weight: 400;
        border-radius: 12px;
        white-space: nowrap;
        text-align: center;
        text-overflow: ellipsis;
        overflow: hidden;
        width: auto;
        height: 24px;
        max-width: 100%;
      }
  }

  &__content {
  position: relative;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.6);
  color: #fff;
  padding: 10px;
  border-radius: 12px;
  height: 229px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;

    .image-card {
      &__main {
        display: flex;
        justify-content: space-between;

        &--left {
          flex: 2;
          padding-left: 10px;

          .image-card-title {
            font-family: 'Helvetica', sans-serif;
            font-weight: 700;
            font-size: 18px;
            line-height: 25.2px;
            letter-spacing: 0%;
            margin-bottom: 2px;
            display: -webkit-box;
            -webkit-line-clamp: 2;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .image-card-description {
            font-size: 14px;
            font-weight: 400;
            line-height: 1.5;
            margin-top: 10px;
            display: -webkit-box;
            -webkit-line-clamp: 3;
            -webkit-box-orient: vertical;
            overflow: hidden;
            text-overflow: ellipsis;
          }
          .image-card-date {
            span {
              font-weight: 400;
              font-size: 11px;
              display: block;
              min-width: 105px;
              height: 13px;
            }
            .image-card-date__location {
              font-weight: 400;
              font-size: 11px;
              height: 13px;
              display: -webkit-box;
              -webkit-line-clamp: 1;
              -webkit-box-orient: vertical;
              overflow: hidden;
              text-overflow: ellipsis;
            }
          }
        }
      }
    }

  .image-card-footer {
    margin-top: auto;
    display: flex;
    justify-content: flex-end;
    position: absolute;
    right: 10px;
    bottom: 10px;

    .read-more {
      background-color: #0056b3;
      color: #fff;
      padding: 8px 12px;
      line-height: 16.8px;
      border: none;
      border-radius: 6px;
      cursor: pointer;
      font-size: 12px;
      font-weight: 600;
      width: 120px;

      &:hover {
        background-color: #004494;
        }
      }
    }
  }
}
</style>